/**
 * Channel constants + label helpers — Phase 3.2.c.
 *
 * Pulled out of admin.js so view modules (channel-settings,
 * message-templates, etc.) can `import { ... } from '../../src/lib/channels.js'`
 * directly instead of receiving them via `configure({helpers})`.
 */

export const CHANNEL_OPTIONS = [
  { key: 'email', label: 'Email', description: 'SMTP/IMAP and outbound email settings for ticket intake.' },
  { key: 'whatsapp', label: 'WhatsApp', description: 'WhatsApp Business API configuration for inbound messages.' },
  { key: 'pbx', label: 'PBX', description: 'PBX webhook credentials and call intake options.' },
  { key: 'app', label: 'INET-Go', description: 'Mobile app (INET-Go) chat and notification settings.' },
];

export const CHANNEL_LABEL_MAP = CHANNEL_OPTIONS.reduce((acc, item) => {
  acc[item.key] = item.label;
  return acc;
}, {});

export function getChannelLabel(channel) {
  return CHANNEL_LABEL_MAP[channel] || (channel ? String(channel).toUpperCase() : 'Channel');
}

export const PBX_EVENT_OPTIONS = [
  ['30012', '30012 – Call completed details'],
  ['30013', '30013 – Call ringing'],
  ['30015', '30015 – Call failure'],
  ['30016', '30016 – Incoming call request'],
  ['30017', '30017 – Agent answered'],
];

export const DEFAULT_PBX_EVENTS = ['30015', '30016', '30012'];
